import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import styled, { useTheme } from 'styled-components';

import { min } from '../../../utils/breakpoints';
import StyledH3 from '../../Styled/StyledH3';

const StyledButton = styled(Button)`
  text-decoration: none;
  font-size: 14px;
  padding: 9px 45px !important;
  border-width: 2px;

  ${min.sm} {
    font-size: 16px;
  }
`;

const SignOutSettings = () => {
  const theme = useTheme();
  const history = useHistory();
  return (
    <div>
      <StyledH3 className="mt-4">Sign out</StyledH3>
      <StyledButton onClick={() => history.push('/sign-out')} className="p-0" variant="secondary">
        Sign out of {theme.language.appName}
      </StyledButton>
    </div>
  );
};

export default SignOutSettings;
